module.exports = __webpack_public_path__ + "img/premium_04.5859de6e.png";